<template>
  <main>
    <div
      ref="platformContent"
      class="download-main-content download-main-middle"
    >
      <div
        v-show="currentIndex === 0"
        :class="['version-list', currentIndex === 0 && 'list-transform']"
      >
        <div class="list-wrap">
          <img
            src="../assets/images/model-iphone-v4.png"
            class="download-machine"
            alt=""
          />
          <div class="download-main-content-download">
            <h1 class="download-title">iPhone/iPad客户端</h1>
            <p class="download-desc">随时随地 高效学习</p>

            <div class="download-platform">
              <img
                src="../assets/images/download-qrcode.png"
                class="erwei-code"
                alt=""
              />
              <span class="download-platform-windows-info download-block"
                >扫描二维码 立即体验</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="currentIndex === 1"
        :class="['version-list', currentIndex === 1 && 'list-transform']"
      >
        <div class="list-wrap">
          <img
            src="../assets/images/model-android-v4.png"
            class="download-machine"
            alt=""
          />
          <div class="download-main-content-download">
            <h1 class="download-title">Android/Pad客户端</h1>
            <p class="download-desc">随时随地 高效学习</p>
            <div class="download-platform">
              <img
                src="../assets/images/download-qrcode.png"
                class="erwei-code"
                alt=""
              />
              <span class="download-platform-windows-info download-block"
                >扫描二维码 立即体验</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="download-clearfix" />
    </div>
    <div class="download-main-content fade-list">
      <ul>
        <li
          v-for="(device, index) in deviceList"
          :key="index"
          :class="[
            'item-v',
            index === currentIndex && 'active',
            index === currentIndex && 'list-transform',
          ]"
          :data-index="index"
          @click="onClick(index)"
        >
          <em class="iconfont" v-html="device.icon" />
          <p class="item-Vcontent">
            {{ device.type }}
          </p>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
/* eslint-disable */
// import request from "@/components/utils/service";
export default {
  name: "Main",
  data() {
    return {
      currentIndex: 0,
      latestLink:
        "https://tx-s.zuoyebang.cc/app/win/10.0.3-04084356/youxueLive_10.0.3_675_27.exe", // 最新版下载链接
      deviceList: Object.freeze([
        {
          icon: "&#xe68a;",
          type: "iPhone版",
        },
        {
          icon: "&#xe629;",
          type: "Android版",
        },
      ]),
    };
  },
  mounted() {
    // request({
    //   method: "post",
    //   url: "https://jx.zuoyebang.com/mercury/object/get",
    //   data: { key: "winyikeStableVersion" },
    // }).then((res) => {
    //   if (+res.data.errNo === 0) {
    //     try {
    //       const resObj = JSON.parse(res.data.data.val);
    //       this.latestLink = resObj.youxue;
    //     } catch (error) {
    //       console.error("解析水星最新版本链接失败", error, res);
    //     }
    //     console.log("latestLink:", this.latestLink);
    //   }
    // });
  },
  methods: {
    onClick(index) {
      this.currentIndex = index;
    },
    onDownLoadLog() {
      new Image().src = "https://notice.zuoyebang.cc/napi/stat/addnoticev1?name=FUDAO_DOWNLOAD_SUCCESS_CLICKED&type=click";
    },
  },
};
</script>

<style lang="less">
.download-main-middle {
  position: relative;
  &::after {
    display: block;
    content: "";
    position: relative;
  }
  .version-list {
    // position: absolute;
    left: 0;
    right: 0;
    top: 0;
    opacity: 0;
    visibility: hidden;
    .list-wrap {
      display: inline-block;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      &::after {
        content: "";
        display: block;
        clear: both;
      }
    }
  }
  .list-transform {
    animation: fadeInChange 0.5s forwards;
    visibility: visible;
  }
}
.fade-list {
  margin-top: 40px;
  margin-bottom: 20px;
  ul {
    width: 100%;
    text-align: center;
    font-size: 0;
    li {
      &.item-v {
        display: inline-block;
        width: 160px;
        height: 46px;
        padding-top: 10px;
        background-color: white;
        cursor: pointer;
        &:first-child {
          border-radius: 4px 0 0 4px;
        }
        &:last-child {
          border-radius: 0 4px 4px 0;
        }
        &:hover {
          background-color: #48c6a1;
          em.iconfont {
            color: white;
          }
          p.item-Vcontent {
            color: white;
          }
        }
        em.iconfont {
          font-size: 18px;
          color: #999;
        }
        p.item-Vcontent {
          font-size: 14px;
          color: #999;
        }
      }
      &.active {
        background-color: #48c6a1;
        em.iconfont {
          color: white;
        }
        p.item-Vcontent {
          color: white;
        }
      }
    }
  }
}

.download-main-content {
  .download-machine {
    width: 671px;
    margin-right: 40px;
    float: left;
  }
  .download-main-content-download {
    width: 350px;
    padding: 20px 0;
    float: right;
    margin-top: 0;
    .download-title {
      font-weight: normal;
      font-size: 38px;
      text-align: center;
      color: #1d3a39;
    }
    .pc-download-title {
      letter-spacing: 12px !important;
    }
  }
}

@media screen and (max-width: 1366px) {
  #download-wrapper
    .download-main
    .download-main-content
    .download-main-content-download
    .download-title {
    font-size: 38px;
  }
}

#download-wrapper
  .download-main
  .download-main-content
  .version-list:first-child
  .download-main-content-download
  .download-title {
  letter-spacing: 1px;
}
#download-wrapper
  .download-main
  .download-main-content
  .download-main-content-download
  .download-desc {
  margin-bottom: 25px;
  margin-top: 5px;
  color: #1d3a39;
  font-size: 16px;
  letter-spacing: 12px;
  text-align: center;
}
#download-wrapper
  .download-main
  .download-main-content
  .version-list:first-child
  .download-main-content-download
  .download-desc {
  margin-bottom: 40px;
}

#download-wrapper
  .download-main
  .download-main-content
  .download-main-content-download
  .download-platform
  .download-btn {
  width: 200px;
  height: 30px;
  line-height: 30px;
  padding: 10px 0;
  display: block;
  border-radius: 4px;
  font-size: 16px;
  margin: auto;
  font-weight: lighter;
  text-align: center;
  /* transition: all 1s; */
}
#download-wrapper
  .download-main
  .download-main-content
  .download-main-content-download
  .download-platform
  .erwei-code {
  display: block;
  width: 150px;
  height: 150px;
  margin: -10px auto 0;
  /* transition: all 1s; */
}

#download-wrapper
  .download-main
  .download-main-content
  .download-main-content-download
  .download-platform
  .download-platform-windows-info {
  padding: 15px 0 20px;
  font-size: 12px;
  text-align: center;
  color: #5e7d74;
}

#download-wrapper
  .download-main
  .download-main-content
  .download-main-content-download
  .download-platform
  .download-platform-windows {
  /*border: 1px solid #fba12d;*/
  box-shadow: 0 3px 15px -3px #fba12d;
  background: linear-gradient(to right top, #fba12d 0%, #fbb52d 100%);
  color: #fff;
  border-radius: 25px;
  font-weight: bold;
}

#download-wrapper
  .download-main
  .download-main-content
  .download-main-content-download
  .download-platform
  .download-platform-windows:hover {
  background: #f0941e;
  /* color: #fba12d; */
}

#download-wrapper
  .download-main
  .download-main-content
  .download-main-content-download
  .download-platform
  .download-platform-windows-xp {
  border: 1px solid #48c6a1;
  background-color: transparent;
  color: #48c6a1;
}

#download-wrapper
  .download-main
  .download-main-content
  .download-main-content-download
  .download-platform
  .download-platform-windows-xp:hover {
  background: #48c6a1;
  color: #fff;
}

@keyframes fadeInChange {
  0% {
    opacity: 0;
    z-index: 1;
  }
  100% {
    opacity: 1;
    z-index: 2;
  }
}
</style>
